"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledResponsiveDialog = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const StyledResponsiveDialog = exports.StyledResponsiveDialog = (0, _mui.styled)(_presentationComponents.ResponsiveDialog)(({
  theme
}) => ({
  [`.${_presentationComponents.responsiveDialogClasses.footer}`]: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: theme.palette.grey[100],
    alignItems: 'center',
    height: 60
  }
}));
